import React, { Component } from 'react';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';
import RetrySvg from '../../assets/svgr/retry/retry.svg';

const ASK_NEW_PASSWORD = gql`
	mutation($email: String!) {
		askForNewPassword(email: $email)
	}
`;

class AskNewPasswordBtn extends Component {
	state = {
		success: false,
	};
	onCompleted = e => {
		this.setState(_ => {
			return { success: true };
		});
	};

	render() {
		return (
			<Mutation
				mutation={ASK_NEW_PASSWORD}
				variables={{
					email: this.props.email,
				}}
				// update={this.updateCache}
				onCompleted={this.onCompleted}
			>
				{(askNewPassword, { data, loading, error }) => {
					if (this.state.success) {
						return <RetrySvg type="completed" />;
					} else if (loading) {
						return <RetrySvg type="loading" />;
					} else {
						return (
							<RetrySvg
								onClick={e => {
									e.preventDefault();
									askNewPassword();
								}}
							/>
						);
					}
				}}
			</Mutation>
		);
	}
}

export default AskNewPasswordBtn;



// WEBPACK FOOTER //
// ./src/components/askNewPasswordBtn/askNewPasswordBtn.js